/*
 * @Author: 晋枫
 * @Date: 2021-09-02 10:54:03
 * @LastEditTime: 2021-09-30 16:26:03
 * @LastEditors: gaochen
 * @Description:
 * @FilePath: /jmj-7v1-task/src/router/modules/bulletinBoard/index.js
 * 🍁YOU CAN（NOT）REDO🍁
 */
import businessRouter from './business'
import managerRouter from './management'
import abnormalRouter from './abnormal'
import workbenchRouter from './workbench'
import workbenchV2Router from './workbenchV2'
import arrangeRouter from './arrange'

const bulletinBoardRouter = [
  {
    path: '/bulletin-auth',
    name: 'auth',
    component: () => import('@/views/wxapp/bulletin-board/auth'),
    meta: {
      title: '授权认证'
    }
  },
  {
    path: '/bulletin-board',
    name: 'BulletinBoard',
    component: () => import('@/views/wxapp/bulletin-board'),
    meta: {
      title: '看板'
    },

    children: [
      ...managerRouter,
      ...businessRouter,
      ...abnormalRouter,
      ...workbenchRouter,
      ...workbenchV2Router,
      ...arrangeRouter
    ]
  },
  {
    path: '/bulletin-board-nokey',
    name: 'BulletinBoardNoKey',
    component: () => import('@/views/wxapp/bulletin-board/routerComponent.vue'),
    meta: {
      title: '看板'
    },

    children: [
      {
        path: 'back-money-board',
        name: 'BackMoneyBoard',
        component: () => import('@/views/wxapp/bulletin-board/back-money-board/index.vue'),
        meta: {
          title: '回款看板'
        }
      },
      {
        path: 'management-order-index-v2',
        name: 'ManagementOrderIndexV2',
        component: () => import('@/views/wxapp/bulletin-board/workbench-v2/managementOrder'),
        meta: {
          title: ''
        }
      }
    ]
  },
  {
    path: '/no-power',
    name: 'NoPower',
    component: () => import('@/views/wxapp/bulletin-board/no-power'),
    meta: {
      title: '暂无权限'
    }
  },
  {
    path: '/department-select',
    name: 'DepartmentSelect',
    component: () => import('@/views/wxapp/bulletin-board/department-select'),
    meta: {
      title: '请选择您关注的部门'
    }
  }
]
export default bulletinBoardRouter
